<template>
  <Base>
    <template v-slot:toolbar>
      <div id="kt_toolbar" class="toolbar">
        <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
          <div class="d-flex align-items-center me-3">
            <slot name="leftToolbar">
              <span class="h-20px border-gray-200 border-start mx-4"></span>
              <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li class="breadcrumb-item text-muted">
                  <router-link :to="{ name: 'dashboard' }" class="text-muted text-hover-primary">
                    <i class="fad fa-home"></i>
                    {{ trans("Dashboard") }}
                  </router-link>
                </li>
              </ul>
            </slot>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:content>
      <LoadingLogo v-if="loading"/>
      <div v-else>
        <div class="d-flex flex-wrap justify-content-between">
          <div class="card m-5 flex-1">
            <div class="card-body">
              <h3 class="card-title">Paramètres</h3>
              <div class="my-5">
                <div class="">
                  <div class="flex-grow-1 px-5">
                    <div class="row">
                      <div class="col col-auto">
                        <div class="mb-3">
                          <label class="form-label">{{ trans("Couleur") }}</label>
                          <div>
                            <input v-model="avenantType.color" type="color">
                          </div>
                        </div>
                      </div>
                      <div class="col col-auto">
                        <div class="mb-3">
                          <label class="form-label">{{ trans("Icone") }}</label>
                          <div>
                            <IconSelector v-model="avenantType.icon"/>
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="mb-3">
                          <label class="form-label">{{ trans("Nom") }}</label>
                          <input v-model="avenantType.label" class="form-control" type="text"/>
                        </div>
                      </div>
                      <div class="col">
                        <div class="mb-3">
                          <label class="form-label">{{ trans("Nom Public") }}</label>
                          <input v-model="avenantType.publicName" class="form-control" type="text"/>
                        </div>
                      </div>
                      <div class="col">
                        <div class="mb-3">
                          <label class="form-label">{{ trans("Code") }}</label>
                          <input v-model="avenantType.code" class="form-control" type="text"/>
                        </div>
                      </div>
                    </div>
                    <div>
                      <label class="form-label">{{ trans("Description") }}</label>
                      <b-form-textarea id="textarea" v-model="avenantType.description" max-rows="6"
                                       placeholder="Description" rows="3"></b-form-textarea>
                    </div>
                  </div>
                  <div class="flex-grow-0 px-5 mt-5">
                    <div class="row" style="gap:20px">
                      <div class="col-auto flex-grow-1">
                        <label :for="'active'" class="form-label">{{ trans("Publique") }}</label>
                        <div>
                          <BooleanInput v-model="avenantType.isPublic"/>
                        </div>
                      </div>
                      <div class="col-auto flex-grow-1">
                        <label :for="'active'" class="form-label">{{ trans("Impacte la prime") }}</label>
                        <div>
                          <BooleanInput v-model="avenantType.isUpdatingPremium"/>
                        </div>
                      </div>
                      <div class="col-auto flex-grow-1">
                        <label :for="'active'" class="form-label">{{ trans("Ajouts") }}</label>
                        <div>
                          <BooleanInput v-model="avenantType.allowAdd"/>
                        </div>
                      </div>
                      <div class="col-auto flex-grow-1">
                        <label :for="'active'" class="form-label">{{ trans("Retraits") }}</label>
                        <div>
                          <BooleanInput v-model="avenantType.allowRemove"/>
                        </div>
                      </div>
                      <div class="col-auto flex-grow-1">
                        <label :for="'active'" class="form-label">{{ trans("Modifications") }}</label>
                        <div>
                          <BooleanInput v-model="avenantType.allowEdit"/>
                        </div>
                      </div>
                      <div class="col-auto flex-grow-1">
                        <label :for="'active'" class="form-label">{{ trans("Création de contrat") }}</label>
                        <div>
                          <BooleanInput v-model="avenantType.allowContractCreation"/>
                        </div>
                      </div>
                      <div class="col-auto flex-grow-1">
                        <label :for="'active'" class="form-label">{{ trans("Modification Effet") }}</label>
                        <div>
                          <BooleanInput v-model="avenantType.allowStartUpdate"/>
                        </div>
                      </div>
                      <div class="col-auto flex-grow-1">
                        <label :for="'active'" class="form-label">{{ trans("Modification Echeance") }}</label>
                        <div>
                          <BooleanInput v-model="avenantType.allowEndUpdate"/>
                        </div>
                      </div>
                      <div class="col-auto flex-grow-1">
                        <label :for="'active'" class="form-label">{{ trans("Change le status") }}</label>
                        <div>
                          <BooleanInput v-model="avenantType.allowStateUpdate"/>
                        </div>
                      </div>
                      <div v-if="avenantType.allowStateUpdate" class="col-auto flex-grow-1">
                        <label :for="'active'" class="form-label">{{ trans("Nouveau Status du contrat") }}</label>
                        <div>
                          <select v-model="avenantType.newStatus"
                                  class="form form-control form-control-solid form-select form-control-lg">
                            <option :value="undefined">Sélectionnez un status</option>
                            <option v-for="(status,index) in contractStatus" :value="status">
                              {{ trans(status) }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row">

                    </div>
                  </div>
                </div>


              </div>

              <div class="my-5">
                <h3 class="card-title">Restreindre les fonctionnalités</h3>
                <div class="flex-grow-1">
                  <b-tabs>
                    <b-tab v-for="cat in categories" :key="'res_'+cat.uuid">
                      <template #title>
                        {{ cat.label }}
                      </template>
                      <b-tabs class="p-5">
                        <div v-if="branchToggled==='none'"
                             class="bg-light-primary text-primary p-10 fs-2x border border-dashed rounded text-center fw-bolder">
                          Sélectionnez des branches si vous voulez restreindre les propriétés éditables
                        </div>
                        <template v-for="branch in cat.branches">
                          <b-tab v-if="isbranchSelected(branch)">
                            <template #title>
                              {{ branch.label }}
                            </template>
                            <div class="p-5 d-flex flex-column">
                              <div v-for="type in branch.items" class="d-flex justify-content-start">
                                <AvenantTypePropertyEditor :avenantType="avenantType" :branch="branch" :item="type"
                                                           :item-types="branch.items"
                                                           @toggleProperty="toggleProperty"/>
                              </div>
                            </div>
                          </b-tab>
                        </template>
                      </b-tabs>
                    </b-tab>
                  </b-tabs>
                </div>

                <div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
          <div class="card m-5 flex-1">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <h3 class="card-title">Branches</h3>
                <div>
                  <label :class="{'opacity-20': branchToggled !== 'none' && branchToggled !== 'all'}"
                         class="form-check form-switch form-check-custom form-check-solid">
                    <input :key="branchToggled" :checked="branchToggled !== 'none'" class="form-check-input" name="active"
                           type="checkbox"
                           @click="toggleAllBranches"/>
                  </label>
                </div>
              </div>
              <div>
                <Loading v-if="loadingBranches"/>
              </div>
              <b-tabs>
                <b-tab v-for="(cat,index) in categories" :key="'b_cat_'+cat.uuid">
                  <template #title>
                    {{ cat.label }}
                  </template>
                  <div class="d-flex flex-wrap my-5">
                    <div v-for="(branch, index2) in cat.branches" :key="'branch_'+index2" class="w-25 my-2">
                      <label class="form-check form-switch form-check-custom form-check-solid">
                        <input :checked="isbranchSelected(branch)" :value="branch.id" class="form-check-input"
                               name="active"
                               type="checkbox"
                               @click="toggleBranch(branch)"/>
                        <span class="form-check-label">
                                  {{ trans(branch.label) }} </span>
                      </label>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
              <div class="d-flex justify-content-between border-top pt-5">
                <h3 class="card-title">Assureurs</h3>
                <div>
                  <label :class="{'opacity-20': insurerToggled !== 'none' && insurerToggled !== 'all'}"
                         class="form-check form-switch form-check-custom form-check-solid">
                    <input :key="insurerToggled" :checked="insurerToggled !== 'none'" class="form-check-input" name="active"
                           type="checkbox"
                           @click="toggleAllInsurer"/>
                  </label>
                </div>
              </div>
              <div>
                <Loading v-if="loadingInsurer"/>
              </div>
              <div class="d-flex flex-wrap my-5">
                <div v-for="(insurer, index) in insurers" :key="index" class="w-25">
                  <div class=" my-2 flex-grow-1">
                    <label class="form-check form-switch form-check-custom form-check-solid">
                      <input :checked="isInsurerSelected(insurer)" class="form-check-input" name="active"
                             type="checkbox" @change="toggleInsurer(insurer)"/>
                      <span class="form-check-label">
                        {{ trans(insurer.label) }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="border-top pt-5">
                <h3 class="card-title">Méthodes de calcul</h3>
                <div class="text-muted my-2">
                  {{ trans("Enregistrer des fonctions dans le scope globale pour les faire apparaître ici") }}
                </div>
                <div class="my-5">
                  <div class="">
                    <div class="mb-3">
                      <label class="form-label">{{ trans("Modification avant calcul") }}</label>
                      <div class="text-muted my-2">
                        {{ trans("Vous permet d'actualiser ou modifier des propriétés avant d'éffectuer le calcul de la prime") }}
                      </div>
                      <div class="d-flex align-items-center justify-content-between">
                        <select v-model="avenantType.preUpdateFunction"
                                class="form form-control form-control-lg form-select-solid form-select">
                          <option :value="null">
                            Séléctionnez une méthode
                          </option>
                          <option v-for="method in engineMethods" :value="{id:method.id,label:method.label}">
                            {{ method.label }}
                          </option>
                        </select>
                        <div class="btn btn-icon btn-primary ms-5">
                          <i class="fad fa-plus"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="">
                    <div class="mb-3">
                      <label class="form-label">{{ trans("Fonction du calcul de la prime") }}</label>
                      <div class="text-muted my-2">
                        {{ trans("Vous permet de calculer le montant de la prime TTC") }}
                      </div>
                      <div class="d-flex align-items-center justify-content-between">
                        <select v-model="avenantType.calculationFunction"
                                class="form form-control form-control-lg form-select-solid form-select">
                          <option :value="null">
                            Séléctionnez une méthode
                          </option>
                          <option v-for="method in engineMethods" :value="{id:method.id,label:method.label}">
                            {{ method.label }}
                          </option>
                        </select>
                        <div v-b-modal="'methodModal'" class="btn btn-icon btn-primary ms-5" @click="createMethod">
                          <i class="fad fa-plus"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="border-top pt-5">
                <h3 class="card-title">Avenants autorisés après cet avenant</h3>
                <div class="my-5 d-flex flex-wrap">

                  <div v-for="type in avenantTypes" :key="'next_'+type.id" class="w-50 my-2 flex-grow-1">
                    <label class="form-check form-switch form-check-custom form-check-solid">
                      <input :checked="avenantType.nextAvenantAllowed.includes(type.id)" class="form-check-input" name="active"
                             type="checkbox"
                             @change="toggleNextAvenant(type)"/>
                      <span class="form-check-label">
                        {{ type.label }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="border-top pt-5">
                <h3 class="card-title">Worflows Activé</h3>
                <div class="my-5 d-flex flex-wrap">

                  <div v-for="workflow in workflows" :key="'workflow_'+workflow.code" class="w-50 my-2 flex-grow-1">
                    <label class="form-check form-switch form-check-custom form-check-solid">
                      <input :checked="avenantType.workflows.includes(workflow.code)" class="form-check-input" name="active"
                             type="checkbox"
                             @change="toggleWorkflow(workflow)"/>
                      <span class="form-check-label">
                        {{ workflow.name }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="border-top pt-5">
                <div class="d-flex justify-content-between align-items-center">
                  <h3 class="card-title">Restriction date d'effet</h3>

                </div>

                <div class="d-flex gap-5 my-5">
                  <div class=" d-flex flex-wrap">
                    <div>Minimum</div>
                    <select v-model="avenantType.minEffect" class="form-control form-select-solid form-select">
                      <option :value="null">{{ trans("Selectionnez une stratégie") }}
                      </option>
                      <option v-for="date in DATES()" :key="date.code_text" :value="date.code_text">
                        {{ trans(date.name) }}
                      </option>
                    </select>
                  </div>
                  <div class="d-flex flex-wrap">
                    <div>Maximum</div>
                    <select v-model="avenantType.maxEffect" class="form-control form-select-solid form-select">
                      <option :value="null">{{ trans("Selectionnez une stratégie") }}
                      </option>
                      <option v-for="date in DATES()" :key="date.code_text" :value="date.code_text">
                        {{ trans(date.name) }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center my-10">
          <div class="btn btn-primary" @click="save">
            <i class="fad fa-save"></i>
            Enregistrer
          </div>
        </div>
      </div>


      <b-modal id="methodModal" ref="methodModal" :title="trans('Calcul')" centered>
        <form>
          <div class="row">
            <div class="col-auto m-2 flex-grow-1">
              <label class="required form-label">{{ trans('Nom') }}</label>
              <div>
                <b-form-input v-model="method.label" :state="!helper.empty(method.label)" class="form-control"
                              type="text">
                </b-form-input>
              </div>
            </div>
            <div class="col-auto m-2 flex-grow-1">
              <label class="required form-label">{{ trans('Nom Public') }}</label>
              <div>
                <b-form-input v-model="method.alias" :state="!helper.empty(method.alias)" class="form-control"
                              type="text">
                </b-form-input>
              </div>
            </div>
            <div class="col-auto m-2 flex-grow-1">
              <label class="form-label">{{ trans('Description') }}</label>
              <div>
                <textarea v-model="method.description" class="form-control"></textarea>
              </div>
            </div>
          </div>
        </form>
        <template #modal-footer="{ ok, cancel, hide }">
          <b-button size="sm" variant="secondary" @click="cancel()">
            <i class="fad fa-times"></i>
            {{ trans('Cancel') }}
          </b-button>
          <b-button size="sm" variant="primary" @click="editMethod()">
            <i class="fad fa-save"></i>
            {{ trans('Save') }}
          </b-button>
        </template>
      </b-modal>

    </template>
  </Base>
</template>
<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {api} from "@/services/Api";
import Base from "@/layouts/Base.vue";
import LoadingLogo from "@/components/LoadingLogo.vue";
import Insurer from "@/entity/Insurer";
import BranchCategory from "@/entity/BranchCategory";
import AvenantType from "@/entity/AvenantType";
import BooleanInput from "@/components/BooleanInput.vue";
import ItemHierarchy from "@/views/Configuration/AvenantType/AvenantTypePropertyEditor.vue";
import AvenantTypePropertyEditor from "@/views/Configuration/AvenantType/AvenantTypePropertyEditor.vue";
import Loading from "@/components/Loading.vue";
import Branch from "@/entity/Branch";
import EngineMethod from "@/entity/EngineMethod";
import CONSTANTS, {DATES} from "@/Utils/constant";
import IconSelector from "@/components/IconSelector.vue";
import {helper} from "@/services/Helper";
import ItemType from "@/entity/ItemType";

@Component({
  methods: {
    DATES() {
      return DATES
    }
  },
  components: {IconSelector, AvenantTypePropertyEditor, Loading, ItemHierarchy, BooleanInput, Base, LoadingLogo},
})
export default class AvenantTypeForm extends Vue {
  categories: BranchCategory[] = []
  insurers: any[] = []

  insurerToggled = 'none'
  branchToggled = 'none'
  loading = false;
  loadingBranches = false
  loadingInsurer = false
  loadingFeatures = false
  tabIndex = 0

  avenantType = new AvenantType();
  method = new EngineMethod()

  workflows = {}
  loadingObjectGroupProperties = false
  loadingProperties = false
  engineMethods: any[] = []
  avenantTypes: any[] = []

  get contractStatus() {
    return CONSTANTS.CONTRACT_STATUS
  }

  createMethod() {
    this.method = new EngineMethod()
  }

  toggleWorkflow(workflow) {
    const index = this.avenantType.workflows.indexOf(workflow.code);
    if (index !== -1) {
      this.avenantType.workflows.splice(index, 1)
    } else {
      this.avenantType.workflows.push(workflow.code)
    }
  }

  toggleNextAvenant(type: any) {
    const index = this.avenantType.nextAvenantAllowed.findIndex((t: any) => {
      return t === type.id
    })
    if (index === -1) {
      this.avenantType.nextAvenantAllowed.push(type.id as never)
    } else {
      this.avenantType.nextAvenantAllowed.splice(index, 1)

    }
  }

  toggleProperty(payload: any) {
    if (this.avenantType.hasOwnProperty(payload.property)) {
      // console.log('has prop')
      const array: any = (this.avenantType as any)[payload.property]
      // console.log(array)
      const index = array.findIndex((uuid: any) => {
        return uuid === payload.uuid
      })
      // console.log(index)
      if (index === -1) {
        array.push(payload.uuid)
      } else {
        array.splice(index, 1)
      }
      Vue.set(this.avenantType, payload.property, array)
    }
    // console.log(this.avenantType)

  }

  mounted(): void {
    this.loadBranchs();
    this.loadInsurers();
    this.loadGlobalMethods()
    this.loadAvenantTypes()
    if (this.$route.params.id) {
      this.loadTypeAvenant();
    }
  }

  checkInsurerToggled() {
    let count = 0
    this.insurers.forEach((i: any) => {
      if (this.isInsurerSelected(i)) {
        count++
      }
    })
    if (count === 0) {
      this.insurerToggled = 'none'
    } else if (count === this.insurers.length) {
      this.insurerToggled = 'all'
    } else {
      this.insurerToggled = 'some'
    }
  }

  toggleInsurer(insurer: any) {
    const index = this.avenantType.insurers.findIndex((i) => {
      return i.id === insurer.id
    })
    if (index === -1) {
      this.avenantType.insurers.push(insurer)
    } else {
      this.avenantType.insurers.splice(index, 1)
    }
    this.checkInsurerToggled()
  }

  isInsurerSelected(insurer: any) {
    const index = this.avenantType.insurers.findIndex((i) => {
      return i.id === insurer.id
    })
    return index !== -1
  }

  toggleAllInsurer() {
    if (this.avenantType.insurers.length === 0) {
      this.avenantType.insurers = []
      this.insurers.forEach((i: any) => {
        this.toggleInsurer(i)
      })
    } else {
      this.avenantType.insurers = []
      this.checkBranchToggled()
    }
  }

  checkBranchToggled() {
    let count = 0
    let branchCount = 0
    this.categories.forEach((cat: any) => {
      cat.branches.forEach((b: any) => {
        if (this.isbranchSelected(b)) {
          count++
        }
        branchCount++
      })
    })
    if (count === 0) {
      this.branchToggled = 'none'
    } else if (count === branchCount) {
      this.branchToggled = 'all'
    } else {
      this.branchToggled = 'some'
    }
  }

  isbranchSelected(branch: any) {
    const index = this.avenantType.branches.findIndex((b) => {
      return b.id === branch.id
    })
    return index !== -1
  }

  toggleBranch(branch: any) {
    const index = this.avenantType.branches.findIndex((b) => {
      return b.id === branch.id
    })
    if (index === -1) {
      this.avenantType.branches.push(new Branch({id: branch.id, slug: branch.slug}))
    } else {
      this.avenantType.branches.splice(index, 1)
    }
    this.checkBranchToggled()
  }

  toggleAllBranches() {
    if (this.avenantType.branches.length === 0) {
      this.categories.forEach((c: any) => {
        c.branches.forEach((b: any) => {
          this.toggleBranch(b)
        })
      })
    } else {
      this.avenantType.branches = []
      this.checkBranchToggled()
    }
  }

  async save() {
    this.$store.commit('loading')
    const res = await api.post(api.core, "avenant/type/edit", this.avenantType);
    this.$store.commit('stopLoading')
    if (res?.data?.avenantType) {
      if (helper.empty(this.$route.params.id)) {
        this.$router.push({name: 'avenant-type-form', params: {id: res.data.avenantType.id}});
      }
    }
  }

  async loadTypeAvenant() {
    this.loading = true;
    const res = await api.get(api.core, "avenant/type/show/" + this.$route.params.id);
    if (res && res.data && res.data.avenantType) {
      this.avenantType = new AvenantType(res.data.avenantType);
      if (this.avenantType.calculationFunction) {
        this.avenantType.calculationFunction = {
          id: this.avenantType.calculationFunction.id,
          label: this.avenantType.calculationFunction.label
        } as any
      }
      if (this.avenantType.preUpdateFunction) {
        this.avenantType.preUpdateFunction = {
          id: this.avenantType.preUpdateFunction.id,
          label: this.avenantType.preUpdateFunction.label
        } as any
      }
      this.checkInsurerToggled()
      this.checkBranchToggled()
    }
    this.loading = false;
  }

  async loadBranchs() {
    this.loadingBranches = true
    const res = await api.get(api.core, 'branch/category/list/with/item/types')
    this.loadingBranches = false
    if (res && res.data && res.data.categories) {
      this.categories = []
      res.data.categories.forEach((cat: BranchCategory) => {
        this.categories.push(new BranchCategory(cat))
        cat.branches.forEach((b: Branch) => {
          b.items.forEach((it: ItemType) => {
            it.workflows.forEach((w: any) => {
              if (!this.workflows[w.code]) {
                this.workflows[w.code] = w
              }
            })
          })
        })
      })
      this.checkBranchToggled()
    }

    this.$forceUpdate()

  }

  async loadGlobalMethods() {
    const res = await api.get(api.core, 'engine/method/list/global')
    if (res && res.data && res.data.methods) {
      this.engineMethods = []
      res.data.methods.forEach((m: any) => {
        this.engineMethods.push({id: m.id, label: m.label})
      })
    }
  }

  async loadInsurers() {
    this.loadingInsurer = true
    const res = await api.get(api.core, "insurer/only/list");
    this.loadingInsurer = false
    if (res && res.data && res.data.insurers) {
      this.insurers = [];
      res.data.insurers.forEach((insurer: Insurer) => {
        this.insurers.push({id: insurer.id, label: insurer.label});
      });
      this.checkInsurerToggled()
    }
  }

  async loadAvenantTypes() {
    const res = await api.get(api.core, 'avenant/type/list')
    if (res && res.data && res.data.types) {
      this.avenantTypes = []
      res.data.types.forEach((t: any) => {
        this.avenantTypes.push({id: t.id, label: t.label})
      })
    }
  }

  async editMethod() {
    this.$store.commit('loading')
    const method = {
      id: this.method.id,
      label: this.method.label,
      description: this.method.description,
      alias: this.method.alias
    }
    let url = 'engine/method/edit';
    const res = await api.post(api.core, url, {method})
    if (this.$refs.methodModal) {
      (this.$refs.methodModal as any).hide()
    }
    this.$store.commit('stopLoading')
    this.method = new EngineMethod()
    this.loadGlobalMethods()
  }


}
</script>
<style scoped></style>
